export enum ConfigurationType {
  Customer = 'CustomerConfiguration',
  Payer = 'PayerConfiguration',
}
